import { API } from "@/lib/api";

const initials = (n = "") => n.split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase();

export const PhotographerAvatar = ({ id, name, version, size = "h-14 w-14 text-lg", testId }) =>
  version ? (
    <img src={`${API}/photographers/${id}/avatar?v=${version}`} alt={name} className={`${size} shrink-0 rounded-2xl object-cover bg-zinc-100`} data-testid={testId} />
  ) : (
    <span className={`${size} shrink-0 rounded-2xl bg-zinc-900 text-white grid place-items-center font-display font-extrabold`} data-testid={testId}>{initials(name)}</span>
  );
